<template>
  <v-container style="height: 100%; overflow-y: auto;" class="align-start principal-body" fluid>
    <div>
      <v-container style="cursor: pointer;">
        <v-row style="font-size: .9em">
          <div class="col-2">
            <b>CIF</b>
          </div>
          <div class="col-2">
            <b>Name</b>
          </div>
          <div class="col-2">
            <b>Byppay</b>
          </div>
          <div class="col-2">
            <b>Crypto</b>
          </div>
          <div class="col-2">
            <b>Stripe</b>
          </div>
          <div class="col-2">
            <b>Bank</b>
          </div>
        </v-row>
      </v-container>
      <v-divider class="borderDivider" />
    </div>
    <div v-for="client in contactClients" :key="client.name" class="background-color col-12">
      <Contact :contact="client" @fetch="fetch" />
      <v-divider class="borderDivider" />
    </div>
    <div v-if="contactClients.length === 0" style="text-align: center; margin-top: 10px">
      <b>{{ $t('There are no clients yet') }}</b>
    </div>
    <v-btn text color="#00E5FF" @click="modalContact = true">
      {{ $t('+ Add Contact') }}
    </v-btn>
    <v-dialog
      ref="dialog"
      v-model="modalContact"
      width="320px"
    >
      <v-form v-model="valid" style="background-color: white;">
        <v-text-field
          v-model="contactName"
          :label="$t('Contact Name')"
          append-icon="mdi-account"
          style="margin-left: 20px; margin-right: 20px; width: 280px;"
          :rules="rules.name"
        />

        <v-text-field
          v-model="contactNIF"
          :label="$t('Contact NIF/CIF')"
          append-icon="mdi-passport"
          style="margin-left: 20px; margin-right: 20px; width: 280px"
          :rules="rules.cif"
        />

        <v-text-field
          v-model="contactEmail"
          :label="$t('Contact Email')"
          append-icon="mdi-email"
          style="margin-left: 20px; margin-right: 20px; width: 280px"
          :rules="rules.email"
        />

        <v-text-field
          v-model="contactPhone"
          :label="$t('Contact phone')"
          append-icon="mdi-phone"
          style="margin-left: 20px; margin-right: 20px; width: 280px"
          :rules="rules.phone"
        />
        <v-btn :disabled="!valid" style="margin-left: 90px" text color="primary" @click="addContact()">
          {{ $t('ADD CONTACT') }}
        </v-btn>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>

import ApiRepository from "../repositories/ApiRepository";
import Contact from "../components/Contact";

export default {
    name: "Clients",
    components: {Contact},
    data () {
        return {
            contactClients: [],
            modalContact: null,
            contactName: "",
            contactNIF: "",
            contactEmail: "",
            contactPhone: "",
            rules: {
                name: [v => !!v || this.$t('A name is required'), ],
                value: [v => !!v || this.$t('The value field is required'), ],
                number: [v => !!v || this.$t('The phone field is required'), ],
                phone: [ v => (/^(\+?[\d ]{9,}|)$/.test(v) || v === null) || this.$t('The phone must be valid') ],
                email: [ v => (/.+@.+\..+/.test(v) || v === "") || this.$t('The mail must be valid.') ],
                cif: [
                    v => !!v || this.$t('A cif is required'),
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || v === '' || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)'),
                    v => v.toUpperCase() !== this.$user.cif.toUpperCase() || this.$t('Error.The CIF must be different than yours.')
                ],
            },
            valid: true
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        async fetch () {
            this.contactClients = [];
            await ApiRepository.getContacts(this.$user.cif).then((res) => {
                this.contactClients = res.data.contacts;
            })
                .catch((err) => {
                    console.log("ERROR: " + err);
                });
        },
        goList () {
            if (this.$user)
                this.$router.push({name: 'InvoiceChats', params: {}, replace: true});
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        async addContact () {
            let contactNameExists = false;
            let contactNIFExists = false;
            let contactEmailExists = false;
            let contactPhoneExists = false;

            for (const user of this.contactClients) {
                if (user.name === this.contactName) contactNameExists = true;
                if (user.cif === this.contactNIF) contactNIFExists = true;
                if (user.mail === this.contactEmail) contactEmailExists = true;
                if (user.phone === this.contactPhone && (user.phone !== null && user.phone !== "")) contactPhoneExists = true;
            }
            if (contactNameExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('Name duplicated'), color: "error"});
            } else if (contactNIFExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('NIF duplicated'), color: "error"});
            } else if (contactEmailExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('Email duplicated'), color: "error"});
            } else if (contactPhoneExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('Phone duplicated'), color: "error"});
            } else {
                const contact = {
                    cif: this.contactNIF,
                    name: this.contactName,
                    email: this.contactEmail,
                    phone: this.contactPhone
                };
                await ApiRepository.addContact(this.$user.cif, contact).then(() => {
                    this.modalContact = false;
                    this.contactName = null;
                    this.contactNIF = null;
                    this.contactEmail = null;
                    this.contactPhone = null;
                    this.$root.$emit('show-snackbar', {message: this.$t('Contact added successfully!'), color: "success"});
                    this.fetch();
                });
            }
        },
    }
};
</script>

<style scoped>


</style>
